"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _autoGenCrumb = _interopRequireDefault(require("./auto-gen-crumb"));

var _clickTrackingCrumb = _interopRequireDefault(require("./click-tracking-crumb"));

var _optionsContext = require("./options-context");

/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable react/no-array-index-key */
var Breadcrumb = function Breadcrumb(props) {
  var _React$useContext = _react.default.useContext(_optionsContext.OptionsContext),
      useAutoGen = _React$useContext.useAutoGen;

  return useAutoGen ? /*#__PURE__*/_react.default.createElement(_autoGenCrumb.default, props) : /*#__PURE__*/_react.default.createElement(_clickTrackingCrumb.default, props);
};

var _default = Breadcrumb;
exports.default = _default;